import React from 'react';
import { Navigate } from 'react-router-dom';

const ClientPortalLoginPage = () => <Navigate to="/" replace />;

export default ClientPortalLoginPage;
